import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Input, Space, Button, Typography } from 'antd';
import objectStore from '../../store/ObjectStore';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import ObjectCard from '../../components/Objects/ObjectCard';
import ObjectModalForm from '../../components/Objects/ObjectModalForm';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Objects = observer(() => {
  const { loading } = objectStore;

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [searchText, setSearchText] = useState(searchParams.get('search') || '');
  const [open, setOpen] = useState(false);
  const [editingObject, setEditingObject] = useState(null);
  
  const filteredObjects = objectStore.filterObjects(searchText);

  useEffect(() => {
    objectStore.fetchObjects();
  }, []);
  
  // Update URL when search changes
  useEffect(() => {
    const params = {};
    if (searchText) params.search = searchText;
    setSearchParams(params, { replace: true });
  }, [searchText, setSearchParams]);

  return (
    <>
      {
          loading?
          <LoadingOutlined/>
          :
          <>
            <Space direction="vertical" style={{ marginBottom: 20 }}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                          setEditingObject(null);
                          setOpen(true);
                      }}
                      >
                      Добавить объект
                    </Button>
                    <Input.Search
                      placeholder="Поиск по объектам..."
                      enterButton
                      allowClear
                      style={{ minWidth: 300 }}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </Space>
                  <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <>
                      {
                        filteredObjects.length === 0 && searchText.length != 0? 
                        (<p>Ничего не найдено :(</p>)
                        :
                        <>
                        {filteredObjects.length == 0?
                            (<p>Ничего нет</p>):
                          (filteredObjects.map((object) => (
                          <ObjectCard key={object.id} object={object} onClick={() => navigate(`/objects/${object.id}`)}/>
                        )))
                      }
                        </>
                        
                      }
                    </>
                  </Space>
                  <ObjectModalForm
                      open={open}
                      onClose={() => setOpen(false)}
                      object={editingObject}
                  />
          </>
      }
    </>
  );
});

export default Objects;
